import { Dialog } from 'evergreen-ui';
import EditGuestForm from './EditGuestForm';

const EditGuestDialog = ({
    isShown,
    onClose,
    guest,
    fetchGuests
}) => {
    return (
        <Dialog
            isShown={isShown}
            title="Modifica ospite"
            onCloseComplete={onClose}
            hasFooter={false}
            shouldAutoFocus={false}
        >
            {guest && (
                <EditGuestForm
                    editedGuest={guest}
                    handleCancelEdit={onClose}
                    fetchGuests={fetchGuests}
                />
            )}
        </Dialog>
    );
};

export default EditGuestDialog;